import { IDocument } from './types';
import DocFileIcon from './doc-file-icon';

interface Props {
  document?: IDocument;
  documents?: IDocument[];
  suggestedQuestions?: string[];
  onSuggestion: (question: string) => void;
}

const DocIntro = ({ document, documents, suggestedQuestions, onSuggestion }: Props) => {
  const docsToRender = documents && documents.length > 0 ? documents : document ? [document] : [];
  const questionsToRender = suggestedQuestions && suggestedQuestions.length > 0 ? suggestedQuestions : document?.suggested_questions;

  if (docsToRender.length === 0) return null;
  if (!docsToRender.some(d => d.summary) && !questionsToRender?.length) return null;

  return (
    <div className='chatBot--doc-intro-card'>
      {docsToRender.map((doc, idx) => (
        <div key={doc.doc_id || idx} style={{ borderBottom: idx < docsToRender.length - 1 && docsToRender.length > 1 ? '1px solid #F2F3F4' : 'none' }}>
          <div className='chatBot--doc-intro-head'>
            <DocFileIcon filename={doc.filename} fontSize={16} />
            <div className='chatBot--doc-intro-head-info'>
              <span className='chatBot--doc-intro-filename'>{doc.filename}</span>
              <span className='chatBot--doc-intro-meta'>
                {doc.category && <>{doc.category}{doc.sub_category ? ` · ${doc.sub_category}` : ''}</>}
              </span>
            </div>
          </div>
          {doc.summary && (
            <div className='chatBot--doc-intro-summary'>{doc.summary}</div>
          )}
        </div>
      ))}

      {questionsToRender && questionsToRender.length > 0 && (
        <div className='chatBot--doc-intro-questions'>
          <div className='chatBot--doc-intro-q-label'>Suggested questions</div>
          {questionsToRender.map((q, i) => (
            <button key={i} className='chatBot--doc-intro-q-btn' onClick={() => onSuggestion(q)}>
              {q}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DocIntro;
